module.exports = __webpack_public_path__ + "static/media/addItemsToRefill.72f51d95.png";